<template>
    <div>
        <slot name="header" :columns="datatable.columns"></slot>
        <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
            <b-row>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('campus')">
                        <campus-selectbox v-model="datatable.queryParams.filter.campus_id"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('building')">
                        <building-selectbox v-model="datatable.queryParams.filter.building_id"
                                            :campus_id="datatable.queryParams.filter.campus_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('classroom_name')">
                        <classroom-selectbox
                            v-model="datatable.queryParams.filter.name"
                            :building_id="datatable.queryParams.filter.building_id"
                            value-type="name"
                            />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('classroom_types')">
                        <parameter-selectbox
                            code="classroom_types"
                            v-model="datatable.queryParams.filter.type"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('seating_types')">
                        <parameter-selectbox
                            code="seating_types"
                            v-model="datatable.queryParams.filter.seating_type"
                        />
                    </b-form-group>
                </b-col>
<!--                <b-col cols="12" md="4">-->
<!--                    <b-form-group :label="$t('board_types')">-->
<!--                        <parameter-selectbox-->
<!--                            code="board_types"-->
<!--                            v-model="datatable.queryParams.filter.board_type"-->
<!--                        />-->
<!--                    </b-form-group>-->
<!--                </b-col>-->
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('display_systems')">
                        <parameter-selectbox
                            code="display_systems"
                            v-model="datatable.queryParams.filter.display_system"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('sound_systems')">
                        <parameter-selectbox
                            code="sound_systems"
                            v-model="datatable.queryParams.filter.sound_system"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('hybrid_statuses')">
                        <parameter-selectbox v-model="datatable.queryParams.filter.hybrid_status"
                                             code="hybrid_statuses"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('technological_materials')">
                        <parameter-selectbox v-model="datatable.queryParams.filter.technological_material"
                                             code="technological_materials"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </datatable-filter>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        />
        <CommonModal ref="showFormModal" size="xxl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('reservation_weeklyprogram')">
            <template v-slot:CommonModalTitle>
                {{ classroom_name.toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <show-form :formId="formId" :classroomName="classroom_name"
                           v-if="formProcess=='show'"/>
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import BuildingSelectbox from '@/components/interactive-fields/BuildingSelectbox'
    import CampusSelectbox from '@/components/interactive-fields/CampusSelectbox'
    import CommonModal from '@/components/elements/CommonModal'
    import DatatableFilter from '@/components/datatable/DatatableFilter'
    import Datatable from '@/components/datatable/Datatable'

    // Pages
    import ShowForm from './ShowForm'

    // Services
    import ReservationService from '@/services/ReservationService'

    // Other
    import qs from 'qs'
    import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";

    export default {
        components: {
            ClassroomSelectbox,
            BuildingSelectbox,
            CampusSelectbox,
            CommonModal,
            DatatableFilter,
            Datatable,

            ShowForm
        },
        data() {
            return {
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-edit-box-line',
                                    permission: 'reservation_weeklyprogram',
                                    hidden: false,
                                    callback: ({id,name}) => {
                                        this.showFormShow(id,name);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase(this.spaceToBR(this.$t('campus'))),
                            field: 'campus_name',
                            sortable: false,
                            formatFn: (value, row) => {
                                return this.getLocaleText(row, 'campus_name', '-')
                            },
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('building')),
                            field: 'building_name',
                            sortable: false,
                            formatFn: (value, row) => {
                                return this.getLocaleText(row, 'building_name', '-')
                            },
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('classroom_name')),
                            field: 'name',
                            sortable: false,
                            formatFn: (value, row) => {
                                return this.getLocaleText(row, 'name', '-')
                            },
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('classroom_types')),
                            field: this.getLocaleField('type_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('classroom')),
                            field: 'capacity',
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('seating_types')),
                            field: this.getLocaleField('seating_type_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:true
                        },
                        // {
                        //     label: this.toUpperCase(this.$t('board_types')),
                        //     field: 'board_type',
                        //     sortable: false,
                        //     thClass: 'text-center',
                        //     tdClass: 'text-center'
                        // },
                        {
                            label: this.toUpperCase(this.$t('display_systems')),
                            field: this.getLocaleField('display_system_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            formatFn: (value, row) => {
                                return row.sound_system === "yes" ? this.$t('yes') :this.$t('no');
                            },
                            hidden:true
                        },
                        {
                            label: this.toUpperCase(this.$t('sound_systems')),
                            field: this.getLocaleField('sound_system_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            formatFn: (value, row) => {
                                return row.sound_system === "yes" ? this.$t('yes') :this.$t('no');
                            },
                            hidden:true
                        },
                        {
                            label: this.toUpperCase(this.$t('hybrid_statuses')),
                            field: this.getLocaleField('hybrid_status_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:true
                        },
                        {
                            label: this.toUpperCase(this.$t('technological_materials')),
                            field: this.getLocaleField('technological_material_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:true
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {
                            campus_id: null,
                            building_id: null,
                            name: null,
                            type: null,
                            seating_type: null,
                            board_type: null,
                            display_system: null,
                            sound_system: null,
                            hybrid_status: null,
                            technological_material: null,
                        },
                        page: 1,
                        limit: 20
                    }
                },
                formId: null,
                formProcess: null,
                classroom_name: ''
            }
        },
        mounted() {
            this.$emit('send-columns', this.datatable.columns);
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {
                    campus_id: null,
                    building_id: null,
                    name: null,
                    type: null,
                    seating_type: null,
                    board_type: null,
                    display_system: null,
                    sound_system: null,
                    hybrid_status: null,
                    technological_material: null,
                }
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return ReservationService.classrooms(config)
                                         .then((response) => {
                                             this.datatable.rows = response.data.data;
                                             this.datatable.total = response.data.pagination.total;
                                         })
                                         .catch((e) => {
                                             this.showErrors(e);
                                         })
                                         .finally(() => {
                                             this.datatable.isLoading = false;
                                         });
            },

            // Clear
            formClear() {
                this.formId = null
                this.formProcess = null
            },

            // Show Form
            showFormShow(id,name) {
                this.formId = id
                this.classroom_name = name
                this.formProcess = 'show'
                this.$refs.showFormModal.$refs.commonModal.show()
            },
            getColumns() {
                return this.columns;
            }
        }
    }
</script>
